import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import QrScanner from 'qr-scanner';
import QrFrame from "../assets/qr-frame.svg";

export default function QrReader(props) {
   const qrBoxEl = useRef(null);  // HTMLDivElement
   const videoEl = useRef(null);  // HTMLVideoElement
   const scanner = useRef(null);  // QrScanner
   const [scannedResult, setScannedResult] = useState("");
   const [qrOn, setQrOn] = useState(true);
   const [camErr, setCamErr] = useState(null);

   const onScanFail = (err: string | Error) => {
      console.log(err);
   };

   const onScanSuccess = (result: QrScanner.ScanResult) => {
      setScannedResult(result?.data);
      scanner?.current?.stop();
      props.callback(result?.data || "");
   };

   useEffect(() => {
      if (videoEl?.current && !scanner.current) {
         // Instantiate the QR Scanner
         scanner.current = new QrScanner(videoEl?.current, onScanSuccess, {
            onDecodeError: onScanFail,
            // In mobile devices, "environment" means back camera and "user" means front camera.
            preferredCamera: "environment",
            // Prevent scanning too often (default = 25 when not used)
            maxScansPerSecond: 1,
            // Position our "QrFrame.svg" so that user can only scan when qr code is in it.
            highlightScanRegion: true,
            // Yellow (default color) outline around the qr code that we scan, proof that our qr-scanner is scanning that qr code.
            highlightCodeOutline: true,
            // div which pairs w/"highlightScanRegion" option above giving us full control over the scan region.
            overlay: qrBoxEl?.current || undefined,
         });

         // Start QR Scanner
         scanner?.current?.start()
            .then(() => setQrOn(true))
            .catch((err) => {
               setCamErr(err);
               setQrOn(false);
            });
      }

      // Remove the QR Scanner from rendering and using camera when it is closed or removed from the UI.
      if (!videoEl?.current) {
         scanner?.current?.stop();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      if (!qrOn) {
         // Surface the real cause so an iOS Safari user can report it on the phone
         // itself (no Mac / remote Web Inspector needed): the getUserMedia error
         // name + a context line. secure/mediaDevices expose an insecure-context
         // failure (e.g. invalid HTTPS cert) that looks like a permission block;
         // standalone flags the iOS home-screen-PWA case. Persistent toast
         // (autoClose:false) so it survives this scanner unmounting.
         // qr-scanner rejects with a plain string (e.g. "Camera not found.")
         // rather than an Error, so handle both: a DOMException gives the precise
         // name (NotAllowedError, etc.); a string is used as-is.
         const detail = camErr instanceof Error
            ? `${camErr.name}: ${camErr.message}`
            : String(camErr ?? "unknown error");
         const standalone = window.navigator.standalone === true
            || window.matchMedia?.("(display-mode: standalone)").matches;
         const diag = `secure=${window.isSecureContext} mediaDevices=${!!navigator.mediaDevices} standalone=${standalone}`;
         console.error("QrReader camera failure:", detail, diag, camErr);
         toast.warning(
            `Camera unavailable — ${detail} — allow camera and reload.  [${diag}]`,
            { autoClose: false }
         );
         props.callbackError();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [qrOn]);

   return (
      <>
         <div className="qr-reader">
            {/* QR */}
            <video ref={videoEl}></video>
            <div ref={qrBoxEl} className="qr-box">
               <img
                  src={QrFrame}
                  alt="Qr Frame"
                  width={256}
                  height={256}
                  className="qr-frame"
               />
            </div>

            {/* Show Data Result if scan is success */}
            {scannedResult && (
               <p style={{ position: "absolute", top: 0, left: 0, zIndex: 99999, color: "white" }} >
                  Scanned Result: {scannedResult}
               </p>
            )}
         </div>
      </>
   );
}
